module.exports = __webpack_public_path__ + "img/hazmat-check.7f153e3e.svg";